import { useMediaQuery } from "@mui/material";
import { createContext, ReactNode, useContext, useState } from "react";

type CommonContextType = {
  isMobile: boolean;
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  titleContext: string;
  setTitleContext: React.Dispatch<React.SetStateAction<string>>;
  showBack: boolean;
  setShowBack: React.Dispatch<React.SetStateAction<boolean>>;
  onBackClick?: () => void;
  setOnBackClick: React.Dispatch<
    React.SetStateAction<(() => void) | undefined>
  >;
};

const CommonContext = createContext<CommonContextType | null>(null);

const CommonContextProvider = ({ children }: { children: ReactNode }) => {
  const isMobile = useMediaQuery("(max-width: 1050px)");
  const [open, setOpen] = useState(!isMobile);
  const [titleContext, setTitleContext] = useState<string>("");
  const [showBack, setShowBack] = useState<boolean>(false);
  const [onBackClick, setOnBackClick] = useState<(() => void) | undefined>();

  return (
    <CommonContext.Provider
      value={{
        isMobile,
        open,
        setOpen,
        titleContext,
        setTitleContext,
        showBack,
        setShowBack,
        onBackClick,
        setOnBackClick,
      }}
    >
      {children}
    </CommonContext.Provider>
  );
};

const useCommonContext = () => {
  const context = useContext(CommonContext);
  if (!context)
    throw new Error("useActiveIndex must be used inside ActiveIndexProvider");
  return context;
};

export { CommonContextProvider, useCommonContext };
